export default "__VITE_ASSET__acfb60e1__"